<script lang="ts">
  import { defineComponent } from "vue";
  import FicheVersementEmployeur from '@/generated/fiches/FicheVersementEmployeur.vue';
  export default defineComponent({
    extends: FicheVersementEmployeur,
    components: {}
})
</script>
